module.exports = __webpack_public_path__ + "media/images/icons/edit-004ac46d7a7a3ef66f8556f88423dc45.svg";